import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#f87676",
        secondary: "#30384d",
        accent: "#10B981",
        error: "#EF4444",
        warning: "#F59E0B",
        info: "#3B82F6",
        success: "#10B981",
        background: "#EDF0F4",
        surface: "#FFFFFF",
      },
      dark: {
        primary: "#E5E5E5",
        secondary: "#525252",
        accent: "#D4D4D4",
        error: "#A3A3A3",
        warning: "#A3A3A3",
        info: "#D4D4D4",
        success: "#D4D4D4",
        background: "#0A0A0A",
        surface: "#171717",
      },
    },
  },
});

export default vuetify;
